import { render, staticRenderFns } from "./resetStatusChangeWarnDetailModal.vue?vue&type=template&id=063a2266&scoped=true"
import script from "./resetStatusChangeWarnDetailModal.vue?vue&type=script&lang=js"
export * from "./resetStatusChangeWarnDetailModal.vue?vue&type=script&lang=js"
import style0 from "./resetStatusChangeWarnDetailModal.vue?vue&type=style&index=0&id=063a2266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063a2266",
  null
  
)

export default component.exports